function validate(key, value, t) {
    const regexInteger = /^[1-9]\d*$/;
    
    switch (key) {
        case 'name':
            if(value?.length === 0){
                return {
                    value: true,
                    helperText: 'pgRole:validate.nameRole.require'
                }
            }
            if(value?.length > 100){
                return {
                    value: true,
                    helperText: 'pgRole:validate.nameRole.max-length'
                }
            }
            return {
                value: false,
                helperText: ''
            }
        case 'description':
            if(value?.length > 250){
                return {
                    value: true,
                    helperText: 'pgRole:validate.descRole.max-length'
                }
            }
            return {
                value: false,
                helperText: ''
            }
        case 'priority':
            if(value?.length === 0){
                return {
                    value: true,
                    helperText: 'pgRole:validate.priority.require'
                }
            }
            if(!regexInteger.test(value)){
                return {
                    value: true,
                    helperText: 'pgRole:validate.priority.positiveNumber'
                }
            }
            if(parseInt(value) > 999999){
                return {
                    value: true,
                    helperText: 'pgRole:validate.priority.max'
                }
            }
            return {
                value: false,
                helperText: ''
            }
        default:
            break;
    }
}

export const handleValidateRole = (data, t) => {
    const error = {
        name: {value: false, helperText: ''},
        description: {value: false, helperText: ''},
        is_active: {value: false, helperText: ''},
        priority: {value: false, helperText: ''},
    }

    Object.keys(error).forEach(key => error[key] = validate(key, data[key], t))
    return error
}